import React from 'react';
import styled from 'styled-components';

function PhotoViewer({ onClose, isFocus, fullImage }) {
  return (
    <Div>
      <section className="pv__content">
        <img src={fullImage} alt="Full image" className="pv__content__image" />
      </section>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  background: white;
  .pv__content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border: 1px solid rgba(0, 0, 0, 0.4);
    overflow: auto;
  }
  .pv__content__image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

export default PhotoViewer;
